export const trimCommas = (str: string) => str.replace(/(^,)|(,$)/g, '');
